import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { CategoryEntity } from "../../entity";

export class ModifyCategoryDTO {
  @Expose()
  @ValidateNested()
  @Type(() => CategoryEntity)
  category!: CategoryEntity;
}
